import React from "react";
import "./NewProj.css";

const projects = [
    {
    title: "Ponderer (2026)",
    role: "Unity / ESP32 Embedded Engineer",
    description: "Ponderer is a mixed reality meditative LED installation that premiered at the Temple Playgrounds artist residency in Montreal, QC.",
    skills: ["C#", "Unity", "ESP32", "Hardware Programming", "Electrical Engineering"],
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/pondererClips.mp4`,
    duration: "3 Months",
    team: "1",
    engine: "Unity (C#)",
    link: "/ponderer",
  },
  {
    title: "So What, Now What? (2025)",
    role: "Unity Developer — Face & Hand Tracking, Network Performance Tools",
    description: "A live theatre performance driven by real-time face and hand tracking, with a custom Unity scene builder and a networked pipeline animating the Glovey character.",
    skills: ["C#", "Unity", "Face Tracking", "Hand Tracking", "Networking"],
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/gloveyFullFinal.mp4`,
    duration: "4 Months",
    team: "2",
    engine: "Unity (C#), ARKit",
    link: "/so-what-now-what",
  },
  {
    title: "Road Smart Interactive (2025)",
    role: "Unity Developer (iOS / VR)",
    description: "Road Smart Interactive is an evidence based, highly interactive road safety education program that consists of a 30-player multiplayer iPad application, along with 2 immersive VR experiences.",
    skills: ["C#", "Unity"],
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/RSI2.mp4`,
    duration: "6 Months",
    team: "2",
    engine: "Unity (C#)",
    link: "/rsi",
  },
  {
    title: "Dream Machine XR (2024)",
    role: "VR Developer (Unity C#)",
    description:
      "Dream Machine is an interactive, multiplayer VR music experience that debuted at the Lincoln Centre in New York in July 2024.",
      video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/dreamMachine.mp4`,
    duration: "6 Months",
    team: "5",
    engine: "Unity (C#)",
    link: "/dream-machine",
  },
  {
    title: "Neuromersiv (2024)",
    role: "VR Developer (Unity C#)",
    description: "Neuromersiv Ulysses aims to assist stroke patients in their functional recovery through hand-tracked VR rehabilitation programs.",
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/neuro.mp4`,
    duration: "3 Months",
    team: "3",
    engine: "Unity",
    link: "/neuro",
  },
  {
    title: "uCat (2023)",
    role: "VR Developer (Unity C#)",
    description: "uCat is a Brain-Computer Interface VR startup that aims to help paralyzed users regain their function and autonomy through the metaverse.",
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/uCat.mp4`,
    duration: "1 Year",
    team: "3",
    engine: "Unity",
    link: "/ucat",
  },
  {
    title: "Sound Storm (2022)",
    role: "Unity Developer (iOS)",
    description: "Sound Storm is an iOS application developed in Unity that helps children suffering from Spatial Processing Disorder through a series of interactive games.",
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/sound.mp4`,
    duration: "6 Months",
    team: "3",
    engine: "Unity",
    link: "/sound",
  },
  {
    title: "Space Breathwork (2025)",
    role: "Unity Developer (WebGL)",
    description: "Space Breathwork is a breathwork application built in Unity to help people engage in various breathwork practices in a relaxing 3D space environment.",
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/space.mp4`,
    duration: "2 Weeks",
    team: "1",
    engine: "Unity",
    link: "/meditation",
  },
  {
    title: "Tech Gym (2018)",
    role: "Unity Developer (UR3 Robot Integration)",
    description: "Tech Gym was a startup at UTS which aimed to help stroke patients in their upper limb recovery through an interactive Unity application linked to a UR3 robotics system.",
    video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/techGym.mp4`,
    duration: "6 Months",
    team: "3",
    engine: "Unity",
    link: "/techGym",
  },
  // {
  //   title: "Orb Pondering XR (Upcoming)",
  //   role: "VR Developer (Unity C#)",
  //     description: "Orb Pondering XR is a fantasy-inspired VR game that uses hand-tracking to ponder, manipulate and shoot various types of magical orbs.",
  //     video: `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/orbDemo.mp4`,
  //   duration: "Ongoing",
  //   team: "12",
  //   engine: "Unity",
  //   link: "/orb",
  // },
  
];

export default function NewProj() {
  return (
    <section className="projects-section">
      <h2>Projects</h2>
      <div className="projects-grid">
        {projects.map((proj, index) => (
          <a href={proj.link} key={index} className="project-card">
            <div className="project-img">
              <video
                src={proj.video}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="project-video"
              />
              <div className="overlay">
                <div className="overlay-text">
                  <span>👥 {proj.team}</span>
                  <span>⏱ {proj.duration}</span>
                  <span>🛠 {proj.engine}</span>
                </div>
              </div>
            </div>
            <div className="project-info">
              <h3>{proj.title}</h3>
              <p className="role">{proj.role}</p>
              <p className="desc">{proj.description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
